module.exports = __webpack_public_path__ + "img/congestion-status-laundry_even.3eaa33a0.svg";